import a from "./_baseGet.js";
var u = a;
function d(e, t, n) {
  var r = e == null ? void 0 : u(e, t);
  return r === void 0 ? n : r;
}
var i = d;
export {
  i as default
};
//# sourceMappingURL=get.js.map
